export const EntityList = [
    {
        value: 'Adventa Health Sdn Bhd', 
        label: 'Adventa Health Sdn Bhd',
    },
    {
        value: 'Cytotec (M) Sdn Bhd', 
        label: 'Cytotec (M) Sdn Bhd',
    },
    {
        value: 'Duramedical Sdn Bhd', 
        label: 'Duramedical Sdn Bhd',
    },
    {
        value: 'Eastern Press Sdn Bhd', 
        label: 'Eastern Press Sdn Bhd',
    },
    {
        value: 'Efficient Security Sdn Bhd', 
        label: 'Efficient Security Sdn Bhd',
    },
    {
        value: 'Flexitech Sdn Bhd', 
        label: 'Flexitech Sdn Bhd',
    },
    {
        value: 'GMP Medicare Sdn Bhd', 
        label: 'GMP Medicare Sdn Bhd',
    },
    {
        value: 'Healthy Hostel Sdn Bhd', 
        label: 'Healthy Hostel Sdn Bhd',
    },
    {
        value: 'Highdeal Capital Sdn Bhd', 
        label: 'Highdeal Capital Sdn Bhd',
    },
    {
        value: 'Purnabina Sdn Bhd', 
        label: 'Purnabina Sdn Bhd',
    },
    {
        value: 'Sentienx Sdn Bhd', 
        label: 'Sentienx Sdn Bhd',
    },
    {
        value: 'Terang Nusa (Malaysia) Sdn Bhd', 
        label: 'Terang Nusa (Malaysia) Sdn Bhd',
    },
    {
        value: 'TG FMT Sdn Bhd', 
        label: 'TG FMT Sdn Bhd',
    },
    {
        value: 'TG Healthcare Sdn Bhd', 
        label: 'TG Healthcare Sdn Bhd',
    },
    {
        value: 'TG Medical Sdn Bhd', 
        label: 'TG Medical Sdn Bhd',
    },
    {
        value: 'TG Meditech Sdn Bhd', 
        label: 'TG Meditech Sdn Bhd',
    },
    {
        value: 'TG Porcelain Sdn Bhd', 
        label: 'TG Porcelain Sdn Bhd',
    },
    {
        value: 'TG Raytech Sdn Bhd', 
        label: 'TG Raytech Sdn Bhd',
    },
    {
        value: 'TG Worldwide Sdn Bhd', 
        label: 'TG Worldwide Sdn Bhd',
    },
    {
        value: 'TG Worldwide Sdn Bhd (Clearing)', 
        label: 'TG Worldwide Sdn Bhd (Clearing)',
    },
    {
        value: 'TG Worldwide Sdn Bhd (Mgt Services)', 
        label: 'TG Worldwide Sdn Bhd (Mgt Services)',
    },
    {
        value: 'TGGD Medical Clinic Sdn Bhd', 
        label: 'TGGD Medical Clinic Sdn Bhd',
    },
    {
        value: 'Top Academy Sdn Bhd', 
        label: 'Top Academy Sdn Bhd',
    },
    {
        value: 'Top Feel Sdn Bhd', 
        label: 'Top Feel Sdn Bhd',
    },
    {
        value: 'Top Glove Chemicals Sdn Bhd', 
        label: 'Top Glove Chemicals Sdn Bhd',
    },
    {
        value: 'Top Glove Corporation Bhd', 
        label: 'Top Glove Corporation Bhd',
    },
    {
        value: 'Top Glove Engineering Sdn Bhd', 
        label: 'Top Glove Engineering Sdn Bhd',
    },
    {
        value: 'Top Glove Global Sdn Bhd', 
        label: 'Top Glove Global Sdn Bhd',
    },
    {
        value: 'Top Glove International Sdn Bhd', 
        label: 'Top Glove International Sdn Bhd',
    },
    {
        value: 'Top Glove Properties Sdn Bhd', 
        label: 'Top Glove Properties Sdn Bhd',
    },
    {
        value: 'Top Glove Sdn Bhd', 
        label: 'Top Glove Sdn Bhd',
    },
    {
        value: 'Top Healthy Fitness Sdn Bhd', 
        label: 'Top Healthy Fitness Sdn Bhd',
    },
    {
        value: 'Top Holiday Hotel Sdn Bhd', 
        label: 'Top Holiday Hotel Sdn Bhd',
    },
    {
        value: 'Top Quality Glove Sdn Bhd', 
        label: 'Top Quality Glove Sdn Bhd',
    },
    {
        value: 'Top Synthetic Rubber Sdn Bhd', 
        label: 'Top Synthetic Rubber Sdn Bhd',
    }
]